module.exports = __webpack_public_path__ + "media/images/landing/second/photo15-0c3ad835bf4b7646be7e8c29c4a9c11d.jpg";